import React, { FC, PropsWithChildren } from "react";
import { usePageSize } from "../../hooks";
import TopDesktop from "./Top.desktop";
import TopMobile from "./Top.mobile";

const Top: FC<{
  desktopClassName?: PropsWithChildren<HTMLDivElement>["className"];
  mobileClassName?: PropsWithChildren<HTMLDivElement>["className"];
}> = ({ desktopClassName, mobileClassName }) => {
  const pageSizes = usePageSize();

  return pageSizes.md ? (
    <TopDesktop className={desktopClassName} />
  ) : (
    <TopMobile className={mobileClassName} />
  );
};

export default Top;
